import axios from "@axios"
import { localListAddItem, localListDeleteItem, localListEnrichLocalId, localListUpdateItem } from '@/store/utils'

export const getInitialPromotionItemForm = () => ({
  id: null,
  skuId: null,
  quantity: null,
  priceFrom: null,
  price: null,
  isDeleted: false,
})

export const getInitialSpendAndGetTierForm = () => ({
  id: null,
  minimumAmount: null,
  rewards: [],
  isDeleted: false,
})

export const getInitialSpendAndGetRewardForm = () => ({
  id: null,
  skuId: null,
  sku: null,
  quantity: null,
  isDeleted: false,
})

const getInitialState = () => ({
  promotion: {
    id: null,
    name: null,
    description: null,
    active: false,
    promotionType: 'Price',
    items: [],
    spendAndGetTiers: [],
    allowAllStores: false,
    stores: [],
    storesSelected: [],
    period: {
      startDate: null,
      endDate: null,
    },
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    getDiscountType(state) {
      return state.promotion.discountType
    },

    getPromotionItems(state) {
      return state.promotion.items.filter(k => !k.isDeleted)
    },

    getSpendAndGetTiers(state) {
      return [...state.promotion.spendAndGetTiers]
        .filter(t => !t.isDeleted)
        .sort((a, b) => (a.minimumAmount || 0) - (b.minimumAmount || 0))
    },
  },

  mutations: {
    SET_PRODUCT_OPTIONS(state, options) {
      state.productOptions = options
    },

    SET_PROMOTION(state, promotion) {
      state.promotion = promotion
    },

    ADD_PROMOTION_ITEM(state, promotionItem) {
      state.promotion.items = localListAddItem(state.promotion.items, {
        ...promotionItem,
        quantity: promotionItem.quantity || null,
      })
    },

    UPDATE_PROMOTION_ITEM(state, { promotionItem }) {
      state.promotion.items = localListUpdateItem(state.promotion.items, promotionItem)
    },

    REMOVE_PROMOTION_ITEM(state, id) {
      state.promotion.items = localListDeleteItem(state.promotion.items, id)
    },

    SET_PROMOTION_TYPE(state, promotionType) {
      state.promotion.promotionType = promotionType
    },

    ADD_SPEND_AND_GET_TIER(state, tier) {
      state.promotion.spendAndGetTiers = localListAddItem(state.promotion.spendAndGetTiers, tier)
    },

    UPDATE_SPEND_AND_GET_TIER(state, { tier }) {
      state.promotion.spendAndGetTiers = localListUpdateItem(state.promotion.spendAndGetTiers, tier)
    },

    REMOVE_SPEND_AND_GET_TIER(state, idOrLocalId) {
      state.promotion.spendAndGetTiers = localListDeleteItem(state.promotion.spendAndGetTiers, idOrLocalId)
    },

    CLEAN_STATE(state) {
      const { promotion } = getInitialState()
      state.promotion = promotion
    },
  },

  actions: {
    async loadPromotionById({ commit }, id) {
      const { data } = await axios.get(`/api/promotions/${id}`)

      // const items = data.items.map(p => ({
      //   ...p,
      //   // skuProduct: { ...p.sku, label: p.sku.name }
      // }))

      commit('SET_PROMOTION', {
        ...data,
        promotionType: data.promotionType,
        spendAndGetTiers: localListEnrichLocalId(
          (data.spendAndGetTiers || []).map(t => ({
            id: t.id,
            minimumAmount: t.minimumAmount,
            isDeleted: false,
            rewards: localListEnrichLocalId(
              (t.rewards || []).map(r => ({
                id: r.id,
                skuId: r.skuId,
                sku: r.sku,
                quantity: r.quantity,
                isDeleted: false,
              }))
            ),
          }))
        ),
        storesSelected: data.stores.map(store => String(store.store.id)),
        period: {
          startDate: data.startDate,
          endDate: data.endDate,
        },
      })
    },

    addPromotionItem({ commit }, promotionItem) {
      commit('ADD_PROMOTION_ITEM', promotionItem)
    },

    updatePromotionItem({ commit }, { promotionItem, index }) {
      commit('UPDATE_PROMOTION_ITEM', { promotionItem, index })
    },

    removePromotionItem({ commit }, index) {
      commit('REMOVE_PROMOTION_ITEM', index)
    },

    setPromotionType({ commit }, promotionType) {
      commit('SET_PROMOTION_TYPE', promotionType)
    },

    addSpendAndGetTier({ commit }, tier) {
      commit('ADD_SPEND_AND_GET_TIER', tier)
    },

    updateSpendAndGetTier({ commit }, { tier, index }) {
      commit('UPDATE_SPEND_AND_GET_TIER', { tier, index })
    },

    removeSpendAndGetTier({ commit }, idOrLocalId) {
      commit('REMOVE_SPEND_AND_GET_TIER', idOrLocalId)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
